import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';

import {
  CLEAR_EHR_APPOINTMENTS,
  LIST_EHR_APPOINTMENTS,
  TOGGLE_EHR_APPOINTMENT_DISCLOSURE,
} from './types';

export const listEhrAppointments = createRoutine(LIST_EHR_APPOINTMENTS);

export const clearEhrAppointments = createAction(CLEAR_EHR_APPOINTMENTS);

export const toggleEhrAppointmentDisclosure = createAction<string>(
  TOGGLE_EHR_APPOINTMENT_DISCLOSURE,
);
